import { Estrutura } from "./layout/Estrutura";
import { PaginaPainel } from "../setores/regulatorio/painel/PaginaPainel";

/**
 * O que se vê depois de entrar.
 *
 * <p>É o <b>painel de risco</b> de Assuntos Regulatórios — decisão registrada
 * em {@code docs/backend/regulatorio.md}: a entrega central do setor é o
 * painel, não um cadastro. O cadastro existe para alimentá-lo.
 *
 * <p>Quando houver mais de um setor, esta rota passa a escolher o painel do
 * setor de quem entrou, a partir das permissões. Até lá, há um setor só.
 */
export function PaginaInicial() {
  return (
    <Estrutura>
      <PaginaPainel />
    </Estrutura>
  );
}
